import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AddressBlock from '../AddressBlock';
import { Container, Box, Title } from './styles';

const AddressInfo = ({
  mail, contact, visit, support,
}) => {
  const { t } = useTranslation('contact');

  return (
    <Container>
      <Box>
        <Title>{t('mail')}</Title>
        <AddressBlock items={mail} />
        <AddressBlock items={contact} />
      </Box>
      <Box>
        <Title>{t('visit')}</Title>
        <AddressBlock items={visit} />
      </Box>
      <Box>
        <Title>{t('support')}</Title>
        <AddressBlock items={support} />
      </Box>
    </Container>
  );
};

AddressInfo.propTypes = {
  mail: PropTypes.instanceOf(Array).isRequired,
  contact: PropTypes.arrayOf(
    PropTypes.object.isRequired,
  ).isRequired,
  visit: PropTypes.arrayOf(
    PropTypes.object.isRequired,
  ).isRequired,
  support: PropTypes.arrayOf(
    PropTypes.object.isRequired,
  ).isRequired,
};

export default AddressInfo;
